module.exports = __webpack_public_path__ + "img/stroke.403ed759.svg";